import * as Redux from 'redux';

export class PricingPageActions {
    public static init(): (dispatch: any) => void {
        return (dispatch: any) => {
            dispatch({ type: 'Pages/Pricing/Init', payload: null });
        };
    }
}
